import React from 'react';

import ContactInfo from './contact-info';
import ContactForm from './contact-form';
const Contact = () => {
  return (
    <div>
      <ContactInfo />
      <ContactForm />
    </div>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/contact/index.js